module.exports = __webpack_public_path__ + "img/tema4.d7f1c823.svg";